import './HeadingElement.css';
function HeadingElement (props){
    return(
        <>
            <div className={props.classname}>
                <h3 className='text-2xl'>{props.title}</h3>
            </div>
        </>
    );
}

export default HeadingElement;
